// extracted by mini-css-extract-plugin
export default {"combinedShieldRoot":"combinedShieldRoot___rYZB3","chef":"chef___xSrAw","s":"s___uEBpt","m":"m___m0GGh","l":"l___RBE8F","combinedShieldImg":"combinedShieldImg___Z8T2w"};